import { api } from '@/lib/api-manager'
import type { Curriculum } from '@/types/courses/curriculum'

export async function getAllEquivalentCurriculumExternalTransfer(
  curriculum?: string
) {
  const response = await api.get(
    'v1/educations/curriculums/external-transfer',
    {
      params: { curriculum }
    }
  )

  const curriculums: Curriculum[] = response.data.data.map((current: any) => ({
    id: current,
    curriculumID: current
  }))

  return curriculums
}
